import type {CategoryGroup, GroupId, GroupRepo} from "../../models/GroupRepo";
import {getStorageKey} from "../../storage";
import {createReactiveLocalStoreByKey} from "../../utils/create-reactive-local-store";

const [useVal, setVal] = createReactiveLocalStoreByKey({
  keyToStorageKey: (key: GroupId) => getStorageKey.lastCatGroupId(key),
});

export const useCatGroup = (groupId: GroupId, groupRepo: GroupRepo) => {
  const lastCatGroupId = useVal(groupId);
  const allCatGroups = groupRepo.CategoryGroups.useGetAll();
  if (lastCatGroupId) {
    const foundCatGroup = allCatGroups[lastCatGroupId] as CategoryGroup | undefined;
    if (foundCatGroup) return foundCatGroup;
  }
  return Object.values(allCatGroups)[0];
};

export const setCatGroup = setVal;
